<template>
  <form-select
    class="special-func-select-v1"
    v-model="val"
    :options="options"
    @change="change"
    v-on="$listeners"
  ></form-select>
</template>
<script>
export default {
  name: 'special-func-select-v1',
  props: {
    lang: String,
    profile: String,
    category: String,
    value: [String, Number],
    packid: String,
    version: String,
  },
  model: {
    prop: 'value',
    event: 'setval',
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('setval', newVal)
      },
    },
  },
  data() {
    return {
      options: [],
      versionmap: {},
    }
  },
  // created() {
  //   this.getFunc()
  // },
  methods: {
    findVersion(funcVersion, version) {
      if (Array.isArray(funcVersion)) {
        for (var item of funcVersion) {
          if (item.version == version) {
            return item
          }
        }
      }
      return null
    },

    findArea(areas, area) {
      if (Array.isArray(areas)) {
        for (var item of areas) {
          if (item == area) {
            return item
          }
        }
      }
      return null
    },
    findPackidAndVersion(vermapItem, packid, version) {
      if (Array.isArray(vermapItem)) {
        for (var item of vermapItem) {
          if (item.packid == packid && item.version == version) {
            return true
          }
        }
      }
      return false
    },
    getFunc() {
      this.$post('view/getFunc', {
        category: this.category,
        lang: this.lang,
        profile: this.profile,
      })
        .then((resp) => {
          if (resp.data.code == 0 && resp.data.data.length > 0) {
            var options = []
            this.versionmap = {}
            for (var item of resp.data.data) {
              if (this.versionmap[item.func]) {
                var versionItem = this.findVersion(
                  this.versionmap[item.func],
                  item.version
                )
                if (versionItem) {
                  if (!this.findArea(versionItem.areas, item.area))
                    versionItem.areas.push(item.area)
                } else {
                  this.versionmap[item.func].push({
                    packid: item.packid,
                    areas: [item.area],
                    version: item.version,
                  })
                }
              } else {
                this.versionmap[item.func] = [
                  {
                    packid: item.packid,
                    areas: [item.area],
                    version: item.version,
                  },
                ]
                options.push(
                  Object.assign(
                    {
                      label: item.func,
                      value: item.func,
                    },
                    item
                  )
                )
              }
            }
            this.options = options
            console.log('versionmap: ',this.versionmap)
            this.val = null
            if (options.length > 0) {
              this.$nextTick(() => {
                if (
                  this.packid != null &&
                  this.packid != '' &&
                  this.version != null &&
                  this.version != ''
                ) {
                  for (var option of options) {
                    let versionmapItem = this.versionmap[option.func]
                    let bool = this.findPackidAndVersion(
                      versionmapItem,
                      this.packid,
                      this.version
                    )
                    if (bool) {
                      //console.log('versionmapItemResult: ',versionmapItem)
                      //console.log('optionResult: ',versionmapItem)
                      this.val=option.value
                      this.$emit('outVersion', option, versionmapItem)
                    }
                  }
                } else {
                  // 优先查找 ABS BLEEDING 满足条件的项
                  const preferred = options.find(opt => opt.value === 'ABS BLEEDING' || opt.value === 'ADBLUE')

                  // 如果找到了优先项，否则用第一个
                  const target = preferred || options[0]

                  this.val = target.value;
                  this.$emit(
                    'outVersion',
                    target,
                    this.versionmap[target.func]
                  );
                }
              })
            }
          } else {
            this.$message('获取功能失败')
          }
        })
        .catch((error) => {
          this.$message('获取功能发生错误=>' + error)
        })
    },
    change(newVal) {
      for (var item of this.options) {
        if (item.func == newVal) {
          //console.log('change: ', this.versionmap[item.func])
          this.$emit('outVersion', item, this.versionmap[item.func])
        }
      }
    },
  },
  watch: {
    profile() {
      this.getFunc()
    },
  },
}
</script>
<style lang="less">
.special-func-select-v1 {
  width: 100px;
}
</style>
